import React from 'react'

import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import Backdrop from '@mui/material/Backdrop';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar'
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import CircularProgress from '@mui/material/CircularProgress';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import NavBar from '../../componentes/Navbar'

import CentralNotificacaoService from '../../app/service/CentralNotificacaoService';
import AtividadeService from '../../app/service/AtividadeService';
import RelatorioAtividadeService from '../../app/service/RelatorioAtividadeService';
import AtividadeComponent from '../atividades/AtividadeComponent';

import './central.css'

class CentralNotificacao extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			openSpinner: false,
			notificacoes: [],
			notificacao: null,
			dataInicial: '',
			dataFinal: '',
			modalAtividade: false,
			atividadeSelecionada: null,
			selectNotificacoes: null,
			paramProcessoPrincipal: ''
		}

		this.centralService = new CentralNotificacaoService();
		this.atividadeService = new AtividadeService();
		this.relatorioAtividadeService = new RelatorioAtividadeService();
	}

	pad2 = (n) => {
		return (n < 10 ? '0' : '') + n;
	}

	formatarDataConsulta = (date) => {
		var month = this.pad2(date.getMonth()+1);
		var day = this.pad2(date.getDate());
		var year = date.getFullYear();
		return year+"-"+month+"-"+day;
	}

	dataVazia = (data) => {
		return data === '' || data === null;
	}

	consultarNotificacoesPorUsuarios = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		await this.centralService.consultarNotificacoesUltimos(usuarioLogado.codigo)
			.then(response => {
				this.setState({notificacoes: response.data});
			}).catch(error => {
				console.log('Erro ', error);
				this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Central de Notificação', detail:`${this.state.detail}`, life: 5000});
			})
	}

	consultarNotificacoes = async () => {
		const usuarioLogado = this.context.usuarioAutenticado;
		const dataInicial = this.state.dataInicial;
		const dataFinal = this.state.dataFinal;

		if(this.dataVazia(dataInicial) && this.dataVazia(dataFinal)) {
			this.setState({openSpinner: true});
			await this.consultarNotificacoesPorUsuarios();
			this.setState({openSpinner: false});
			return;
		}

		if(this.dataVazia(dataInicial) || this.dataVazia(dataFinal)) {
			this.toast.show({severity:'error', summary: 'Central de Notificação', detail:'As duas datas precisam ser preenchidas', life: 5000});
			return;
		}

		var dataInicialFormatada = this.formatarDataConsulta(dataInicial);
		var dataFinalFormatada = this.formatarDataConsulta(dataFinal);

		this.setState({openSpinner: true});
		await this.centralService.consultarPorDatas(usuarioLogado.codigo, dataInicialFormatada, dataFinalFormatada)
			.then(response => {
				this.setState({notificacoes: response.data});
			}).catch(error => {
				this.setState(error.response.data);
				this.toast.show({severity:'error', summary: 'Central de Notificação', detail:`${this.state.detail}`, life: 5000});
			})
		this.setState({openSpinner: false});
	}

	statusBodyTemplate = (rowData) => {
		return (
			<Tag 
				value={rowData.statusCalculado}
				severity={rowData.status === 'LIDO' ? 'success' : 'secondary'} 
			/>
		)
	}

	atividadeBodyTemplate = (rowData) => {
		if (!rowData.atividade) {
			return '';
		}

		return (
			<a 
				onClick={() => this.abrirAtividade(rowData)}
				style={{cursor: 'pointer', color: 'blue'}}>
				{rowData.atividade.titulo}
			</a>
		)
	}

	alterarStatus = async (notificacao) => {
		await this.centralService.alterarSttaus(this.state.notificacao.codigo,
			notificacao.status === "NAO_LIDO" ? "LIDO" : "NAO_LIDO"
		).then(response => {
			this.consultarNotificacoes();
		}).catch(error => {
			this.setState(error.response.data);
			this.toast.show({severity:'error', summary: 'Notificações', detail:`${this.state.detail}`, life: 4000});
		})
	}

	//Notificação com planilha (ex.: relatório do processamento de publicações)
	relatorioBodyTemplate = (rowData) => {
		if (!rowData.relatorio) {
			return '';
		}

		return (
			<Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
							tooltip="Baixar relatório"
							tooltipOptions={{position: 'top'}}
							onClick={() => this.baixarRelatorio(rowData)} />
		)
	}

	baixarRelatorio = async (rowData) => {
		this.setState({openSpinner: true});
		await this.relatorioAtividadeService.download(rowData.relatorio)
			.then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `relatorio_publicacoes_${rowData.relatorio}.xlsx`);
				document.body.appendChild(link);
				link.click();
				link.remove();
				window.URL.revokeObjectURL(url);
			}).catch(error => {
				this.toast.show({severity:'error', summary: 'Central de Notificações', detail:`Erro ao baixar o relatório: ${error}`, life: 4000});
			})
		this.setState({openSpinner: false});
	}

	processoBodyTemplate = (rowData) => {
		var processo = '';
		if (!rowData.processo) {
			return '';
		}

		if(rowData.processo.nrCnj) {
			var cnjMascarado = rowData.processo.nrCnj.substring(0, 7);
					cnjMascarado = cnjMascarado + "-" + rowData.processo.nrCnj.substring(7, 9);
					cnjMascarado = cnjMascarado + "." + rowData.processo.nrCnj.substring(9, 13);
					cnjMascarado = cnjMascarado + "." + rowData.processo.nrCnj.substring(13, 14);
					cnjMascarado = cnjMascarado + "." + rowData.processo.nrCnj.substring(14, 16);
					cnjMascarado = cnjMascarado + "." + rowData.processo.nrCnj.substring(16, 20);
			processo = cnjMascarado;
		} else if(rowData.processo.nrProcesso) {
			processo = rowData.processo.nrProcesso;
		} else {
			processo = rowData.processo.pasta;
		}

		return (
			<a style={{cursor: 'pointer', color: 'blue'}} 
				 href={this.state.paramProcessoPrincipal}
				 target="_blank"
				 onClick={() => this.consultarProcesso(rowData)}>{processo}</a>
		)
	}

	async consultarProcesso(notificacao){
		this.setState({paramProcessoPrincipal: `#/fichaProcesso/${notificacao.processo.codigo}/SEARCH`});
  }

	abrirAtividade = async (notificacao) => {
		const usuarioLogado = this.context.usuarioAutenticado;

		this.setState({notificacao: notificacao});

		this.setState({openSpinner: true});
		await this.atividadeService.consultarAtividadeCustom(notificacao.atividade.codigo, usuarioLogado.empresa.codigo, usuarioLogado.codigo)
			.then(response => {
				this.setState({
					atividadeSelecionada: response.data,
					modalAtividade: true
				});
				if(notificacao.status === 'NAO_LIDO') {
					this.alterarStatus(notificacao);
				}
			}).catch(error => {
				this.setState(error.response.data);
				this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
			})
		this.setState({openSpinner: false});
	}

	fecharAtividade = () => {
		this.setState({
			modalAtividade: false
		});
	}

	onAtividadeAlterada = () => {
		this.consultarNotificacoes();
	}

	rowClassName = (rowData) => {
		return {
			'linha-lida': rowData.status === 'NAO_LIDO'
		}
	}

	formatarData = (rowData) => {
		if (!rowData.dataRegistro) {
			return '';
		}

		const data = new Date(rowData.dataRegistro);

		return data.toLocaleDateString('pt-BR');
	}

	confirmarExclusaoNotificacoes = () => {
		if(this.state.selectNotificacoes == null || this.state.selectNotificacoes.length == 0) {
			this.toast.show({severity:'error', summary: 'Central de Notificação', detail:'Nenhuma notificação foi selecionada', life: 5000});
			return;
		}

		confirmDialog({
			message: 'Deseja realmente excluir as notificações selecionadas?',
			header: 'Exclusão de Notificações',
			icon: 'pi pi-info-circle',
			acceptClassName: 'p-button-danger',
			acceptLabel: 'Sim',
			rejectLabel: 'Não',
			accept: this.excluirNotificacoes
		});
	}

	excluirNotificacoes = async () => {
		this.setState({openSpinner: true});
		await this.centralService.excluirNotificacoes(this.state.selectNotificacoes)
			.then(response => {
				this.toast.show({severity:'success', summary: 'Central de Notificação', detail:'Notificações excluídas com sucesso', life: 4000});
				this.setState({selectNotificacoes: null});
				return this.consultarNotificacoes();
			}).catch(error => {
				this.setState(error.response.data);
				this.toast.show({severity:'error', summary: 'Central de Notificação', detail:`${this.state.detail}`, life: 5000});
			})
		this.setState({openSpinner: false});
	}

	confirmarMarcarComoLidas = () => {
		if(this.state.selectNotificacoes == null || this.state.selectNotificacoes.length == 0) {
			this.toast.show({severity:'error', summary: 'Central de Notificação', detail:'Nenhuma notificação foi selecionada', life: 5000});
			return;
		}

		confirmDialog({
			message: 'Deseja realmente marcar as notificações selecionadas como lidas?',
			header: 'Marcar Notificações como Lidas',
			icon: 'pi pi-info-circle',
			acceptClassName: 'p-button-success',
			acceptLabel: 'Sim',
			rejectLabel: 'Não',
			accept: this.marcarComoLidas
		});
	}

	marcarComoLidas = async () => {
		this.setState({openSpinner: true});
		await this.centralService.marcarcomoLidos(this.state.selectNotificacoes)
			.then(response => {
				this.toast.show({severity:'success', summary: 'Central de Notificação', detail:'Notificações marcadas como lidas com sucesso', life: 4000});
				this.setState({selectNotificacoes: null});
				return this.consultarNotificacoes();
			}).catch(error => {
				this.setState(error.response.data);
				this.toast.show({severity:'error', summary: 'Central de Notificação', detail:`${this.state.detail}`, life: 5000});
			})
		this.setState({openSpinner: false});
	}

	async componentDidMount() {
		this.setState({openSpinner: true});
		await this.consultarNotificacoesPorUsuarios();
		this.setState({openSpinner: false});
	}

	render() {
		return(
			<>
				<NavBar />
				<Toast ref={(el) => this.toast = el} />
				<ConfirmDialog />
				<Backdrop
					sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={this.state.openSpinner}>
					<CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
				</Backdrop>

				<AtividadeComponent
						visible={this.state.modalAtividade}
						atividade={this.state.atividadeSelecionada}
						onHide={this.fecharAtividade}
						onAtividadeAlterada={this.onAtividadeAlterada}
				/>

				<div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-envelope"></i>
                        <span> Central de Notificações</span>
                      </h3>  
                    </div>
										<div className="card-body">
                      <div className="row">
                        <div className="col-md-2">
													<div className="form-group">
														<Calendar id="idConsultaPorDataInicial"
																			value={this.state.dataInicial}
																			onChange={(e) => this.setState({ dataInicial: e.value })}
																			locale="es"
																			style={{width: '100%', height: '32px'}}
																			dateFormat="dd/mm/yy"
																			placeholder="Dt Inicial"
																			mask="99/99/9999"/>
													</div>
												</div>
												<div className="col-md-2">
													<div className="form-group">
														<Calendar id="idConsultaPorDataFinal"
																			value={this.state.dataFinal}
																			onChange={(e) => this.setState({ dataFinal: e.value })}
																			locale="es"
																			style={{width: '100%', height: '32px'}}
																			dateFormat="dd/mm/yy"
																			placeholder="Dt Final"
																			mask="99/99/9999"/>
													</div>
												</div>
												<div className="col-md-8">
													<div className="form-group" style={{display: 'flex', flexWrap: 'nowrap'}}>
														 <Button style={{height: '32px', whiteSpace: 'nowrap'}} type="button" className="p-button-info p-button-sm"
																	onClick={this.consultarNotificacoes}>
															<i className="fas fa-search"></i>&nbsp;&nbsp;Consultar</Button>
														 <Button style={{height: '32px', marginLeft: '8px', whiteSpace: 'nowrap'}} type="button" className="p-button-success p-button-sm"
																	onClick={this.confirmarMarcarComoLidas}>
															<i className="fas fa-check"></i>&nbsp;&nbsp;Marcar como lidas</Button>
														 <Button style={{height: '32px', marginLeft: '8px', whiteSpace: 'nowrap'}} type="button" className="p-button-danger p-button-sm"
																	onClick={this.confirmarExclusaoNotificacoes}>
															<i className="fas fa-trash"></i>&nbsp;&nbsp;Excluir</Button>
													</div>
												</div>
                      </div>
											<div className="row">
												<div className="col-md-12">
													<DataTable 
														value={this.state.notificacoes}
														responsiveLayout="scroll"
														emptyMessage="Nenhuma notificação encontrada"
														selection={this.state.selectNotificacoes} 
														onSelectionChange={(e) => this.setState({ selectNotificacoes: e.value })}
														rowClassName={this.rowClassName}
													>
														<Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
														<Column field="mensagem" header="Notificação"></Column>
														<Column 
															field="atividade.titulo" 
															header="Atividade"
															body={this.atividadeBodyTemplate}
														></Column>
														<Column 
															field="processo.nrCnj" 
															header="Processo"
															body={this.processoBodyTemplate}
														></Column>
														<Column 
															field="relatorio" 
															header="Relatório"
															body={this.relatorioBodyTemplate}
														></Column>
														<Column 
															field="dataRegistro" 
															header="Data"
															body={this.formatarData}
														></Column>
														<Column 
															field="status" 
															header="Status"
															body={this.statusBodyTemplate}
														></Column>
													</DataTable>
												</div>
											</div>
                    </div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</>
		)
	}
}

CentralNotificacao.contextType = AuthContext;
export default withRouter (CentralNotificacao)
